import QuotationError from './QuotationError';
class QuotationNumberOfBricksExceeds extends QuotationError {
    constructor(options) {
        super('More Bricks than this investor is allowed to buy under the UDI limit', options);
    }
}
export default QuotationNumberOfBricksExceeds;
